import React, { useContext } from 'react';
import { GlobalCtx } from '../context/GlobalContext';
import styled from 'styled-components';
import { useTranslation, Trans } from 'react-i18next';
import Header from '../components/Header';
import { COLORS, MEDIA_QUERIES } from '../Variables';
import Footer from '../components/Footer';

const NotFoundPageContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  margin: 10vh 0;
  @media ${MEDIA_QUERIES.TABLET} {
    margin: 25vh 0 5vh;
  }
  p {
    font-size: 100px;
  }
  p.zero {
    color: ${(props) =>
      props.lang === 'hazteoir' ? COLORS.hoOrange : COLORS.cgoBlue};
  }
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  p {
    font-weight: 700;
    font-size: 20px;
    margin-bottom: 20px;
    a {
      color: ${(props) =>
        props.lang === 'hazteoir' ? COLORS.hoOrange : COLORS.cgoBlue};
    }
  }
`;

const Box = styled.div`
  height: ${(props) => props.lang === 'hazteoir' ? '33vh' : '40vh'};
  text-align: center;
  line-height: 1.4;
  @media ${MEDIA_QUERIES.TABLET} {
    height: 40vh;
    padding: 0 20px;
  }
`;

const NotFoundPage = () => {
  const { lang } = useContext(GlobalCtx);
  const { t } = useTranslation();

  return (
    <>
      <Header />
      <Box lang={lang} >
        <NotFoundPageContainer lang={lang}>
          <p>4</p>
          <p className="zero">0</p>
          <p>4</p>
        </NotFoundPageContainer>
        <TextContainer lang={lang}>
          <p>{t('not_found_page_text_top')}</p>
          <p>
          <Trans i18nKey={'not_found_page_text_bottom'} >
            X <a
              href={t('footer.helpscout_link')}
              target="_blank"
              rel="noreferrer"
            >Y
            </a>Z
          </Trans>
          </p>
        </TextContainer>
      </Box>
      <Footer />
    </>
  );
};

export default NotFoundPage;
